import { render, staticRenderFns } from "./PromotionHistoryCard.vue?vue&type=template&id=848a315a"
import script from "./PromotionHistoryCard.vue?vue&type=script&lang=js"
export * from "./PromotionHistoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports